import { render, staticRenderFns } from "./FormattedNoteText.vue?vue&type=template&id=640cad38&"
import script from "./FormattedNoteText.vue?vue&type=script&lang=js&"
export * from "./FormattedNoteText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports